import React, { useEffect, useState } from 'react';
import {useDispatch, useSelector} from "react-redux";
import { optimizePortfolio } from '../../../redux/actions/stockActions';
import CircularSpinner from '../../utils/CircularSpinner';
import Optimal from './Optimal';


const Optimization = ({stocks}) => {
    const userID = useSelector(state => state.user?.user?._id);
    const dispatch = useDispatch();
    const [optimal, setOptimal] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const optimize = async () => {
        const data = {
            userID: userID
        }
        setIsLoading(true);
        const response = await dispatch(optimizePortfolio(data));
        if(response.status === 200){
            setOptimal(response.data.optimalPortfolio);
        }else{

        }
        setIsLoading(false);
    }

    useEffect(() => {
        // optimize()
        // eslint-disable-next-line
    }, [])

    return (
            <div className="w-100 mt-5 ">
                {
                    isLoading
                    ? <CircularSpinner />
                    : <Optimal optimal={optimal}/>
                }
            </div>
    )
}

export default Optimization
